/**
 * Artikelcode `MMMM-RRR-AAA` = Mieternummer (4-stellig) – Regalnummer (3-stellig) – Laufnummer (3-stellig).
 * Im QR-Code steht `RL:1234-055-025`. Der Parser akzeptiert 3–4 Stellen je Block, damit eine
 * spätere Erweiterung ohne Umbau möglich ist (Plan 2.3, Frage 10).
 */

export const QR_PRAEFIX = "RL:";

export interface ArtikelCode {
  mieternummer: string;
  regalnummer: string;
  laufnummer: string;
  code: string;
}

const MUSTER = /^(\d{4})-(\d{3,4})-(\d{3,4})$/;

export function parseArtikelCode(eingabe: string): ArtikelCode | null {
  let s = eingabe.trim();
  if (s.toUpperCase().startsWith(QR_PRAEFIX)) s = s.slice(QR_PRAEFIX.length);
  const m = MUSTER.exec(s);
  if (!m) return null;
  const [, mieternummer, regalnummer, laufnummer] = m as unknown as [string, string, string, string];
  return { mieternummer, regalnummer, laufnummer, code: `${mieternummer}-${regalnummer}-${laufnummer}` };
}

export function bildeArtikelCode(mieternummer: string, regalnummer: string, laufnummer: number): string {
  const lauf = laufnummer.toString().padStart(3, "0");
  return `${mieternummer.padStart(4, "0")}-${regalnummer.padStart(3, "0")}-${lauf}`;
}

export function qrInhalt(code: string): string {
  return QR_PRAEFIX + code;
}

/** Regalnummer im QR auf dem Regalschild: `RL:R-055` (Version 2, Einräumen per QR). */
export function parseRegalQr(eingabe: string): string | null {
  const m = /^RL:R-(\d{3,4})$/.exec(eingabe.trim());
  return m ? (m[1] as string) : null;
}
